import { defineMessages } from "react-intl";

export default defineMessages({
    vehicleOwnedorleased: {
        id: "ml.quoteandbind.pa.vehicle.Is this vehicle owned, financed or leased?",
        defaultMessage: "Is this vehicle owned, financed or leased?",
    },
    leased: {
        id: "ml.quoteandbind.pa.vehicle.financeCategory.leased",
        defaultMessage: "Leased",
    },
    financed: {
        id: "ml.quoteandbind.pa.vehicle.financeCategory.financed",
        defaultMessage: "Financed",
    },
    owned: {
        id: "ml.quoteandbind.pa.vehicle.financeCategory.owned",
        defaultMessage: "Owned",
    },
    nonOwned: {
        id: "ml.quoteandbind.pa.vehicle.financeCategory.nonOwned",
        defaultMessage: "Non-owned",
    },
    vehicleYear: {
        id: "ml.quoteandbind.pa.vehicle.What year was the vehicle purchased?",
        defaultMessage: "What year was the vehicle purchased?",
    },
    vehiclePurchaseDate: {
        id: "ml.quoteandbind.pa.vehicle.When was the vehicle purchased?",
        defaultMessage: "When was the vehicle purchased?",
    },
    vehiclePurchase: {
        id: "ml.quoteandbind.pa.vehicle.Was the vehicle purchased in the last 6 months?",
        defaultMessage: "Was the vehicle purchased in the last 6 months?",
    },
    vehicleUse: {
        id:
            "ml.quoteandbind.pa.vehicle.How will this vehicle be used most of the time?",
        defaultMessage: "How will this vehicle be used most of the time?",
    },
    vehicleMileage: {
        id:
            "ml.quoteandbind.pa.vehicle.How many miles do you drive this vehicle per year?",
        defaultMessage: "How many miles do you drive this vehicle per year?",
    },

    vehicleParkedatResidence: {
        id:
            "ml.quoteandbind.pa.vehicle.Is the vehicle primarily parked at your residence?",
        defaultMessage: "Is the vehicle primarily parked at your residence?",
    },

    trailerParkedatResidence: {
        id:
            "ml.quoteandbind.pa.vehicle.Is the trailer primarily parked at your residence?",
        defaultMessage: "Is the trailer primarily parked at your residence?",
    },

    vehicleParking: {
        id: "ml.quoteandbind.pa.vehicle.Where is the vehicle parked?",
        defaultMessage: "Where is the vehicle parked?",
    },

    workonadditionalVehicles: {
        id: "ml.quoteandbind.pa.vehicle.Well work on your additional vehicles next",
        defaultMessage: "We will work on your additional vehicles next",
    },

    whatDoesitMean: {
        id: "ml.quoteandbind.pa.vehicle.What does this mean?",
        defaultMessage: "What does this mean?",
    },

    whatIsNonOwned: {
        id: "ml.quoteandbind.pa.vehicle.financeCategory.What is non-owned?",
        defaultMessage: "What is non-owned?",
    },

    whatIsNonOwnedTooltipContent: {
        id: "ml.quoteandbind.pa.vehicle.financeCategory.Non-owned tooltip content",
        defaultMessage:
            "This vehicle is not owned by the insured but has been provided for their regular use.",
    },
    whatIsNonOwnedTooltipContentQb: {
        id: "ml.quoteandbind.pa.vehicle.financeCategory.Non-owned tooltip contentQb",
        defaultMessage:
            "This vehicle is not owned by the named insured but has been provided for regular use.",
    },

    whatIsBusinessUse: {
        id: "ml.quoteandbind.pa.vehicle.What is business use?",
        defaultMessage: "What is business use?",
    },

    businessUseTooltipContent: {
        id: "ml.quoteandbind.pa.vehicle.businessuse.Business use tooltip content",
        defaultMessage:
            "This is using your personal vehicle for business purposes such as visiting customers, making deliveries or picking up supplies/equipment on behalf of a business. For example, a realtor using their personal vehicle to transport clients to see homes.",
    },

    parkedatPrimaryTooltipContent: {
        id: "ml.quoteandbind.pa.vehicle.parkedatprimary.tooltip content",
        defaultMessage:
            "The vehicle is typically parked at the address listed on the policy. The vehicle can be parked in the garage, carport, on street or off street. If the vehicle is typically parked at a different address, list the address.",
    },

    value: {
        id: "ml.quoteandbind.pa.vehicle.Value",
        defaultMessage: "Value",
    },

    valueTooltipHeader: {
        id: "ml.quoteandbind.pa.vehicle.value.What does value mean?",
        defaultMessage: "What does value mean?",
    },

    valueToltipContentNH: {
        id: "ml.quoteandbind.pa.vehicle.value.NH tooltip content",
        defaultMessage:
            "For trailers or low speed vehicles, the value is based on the cost to sell or purchase the vehicle or trailer. For classic, antique vehicles and other personally registered vehicles, the value entered should be the current market value or the vehicle appraisal value, if available.",
    },

    valueToltipContentAZ: {
        id: "ml.quoteandbind.pa.vehicle.value.AZ tooltip content",
        defaultMessage:
            "For trailers, low speed vehicles or registered golf carts, the value is based on the cost to sell or purchase the vehicle or trailer. For classic and antique vehicles, the value entered should be the current market value or the vehicle appraisal value, if available.",
    },

    valueToltipContentRest: {
        id: "ml.quoteandbind.pa.vehicle.value.Rest tooltip content",
        defaultMessage:
            "For trailers or low speed vehicles, the value is based on the cost to sell or purchase the vehicle or trailer. For classic and antique vehicles, the value entered should be the current market value or the vehicle appraisal value, if available.",
    },

    costNew: {
        id: "ml.quoteandbind.pa.vehicle.Cost New",
        defaultMessage: "Cost New",
    },

    costNewTooltipHeader: {
        id: "ml.quoteandbind.pa.vehicle.CostNew.What is cost new?",
        defaultMessage: "What is cost new?",
    },

    costNewTooltipContent: {
        id: "ml.quoteandbind.pa.vehicle.CostNew.Tooltip Content",
        defaultMessage:
            "Cost new is the original manufacturer’s purchase price based on the year the vehicle was made. We require you to enter the cost new in the following situations: when you do not enter a VIN when quoting; when we are unable to verify your vehicle base on the VIN entered; or when your vehicle is either brand new or a 1980 or older model.",
    },

    conditionField: {
        id: "ml.quoteandbind.pa.vehicle.Was the vehicle purchased new or used?",
        defaultMessage: "Was the vehicle purchased new or used?",
    },
    commonHvqValidationMessage: {
        id: "ml.quoteandbind.pa.vehicle.Verify or update above information",
        defaultMessage: "Verify or update above information",
    },
    reviewVehicle: {
        id: "ml.quoteandbind.pa.vehicle.hvq.Review the identified fields for your vehicles",
        defaultMessage: "Review the identified fields for your vehicles",
    },
    verifyPrefilledInfo: {
        id: "ml.quoteandbind.pa.vehicle.hvq.Verify the information we prefilled for you",
        defaultMessage: "Verify the information we prefilled for you",
    },
    MNIgnitionInterlock: {
        id: "ml.quoteandbind.pa.vehicle.Interlock.Do you require a MN Ignition Interlock Insurance Certification Form?",
        defaultMessage: "Do you require a MN Ignition Interlock Insurance Certification Form?",
    },
    interlockExpiration: {
        id: "ml.quoteandbind.pa.vehicle.Interlock.expiration.Interlock Expiration Date",
        defaultMessage: "Interlock Expiration Date",
    },
    deliveryProducts: {
        id: "ml.quoteandbind.pa.vehicle.delivery.products.Do you delivery any products or goods with this vehicle?",
        defaultMessage: "Do you delivery any products or goods with this vehicle?",
    },
    selectProducts: {
        id: "ml.quoteandbind.pa.vehicle.select.products.Please select the type of products you deliver",
        defaultMessage: "Please select the type of products you deliver",
    },
    deliveryPeople: {
        id: "ml.quoteandbind.pa.vehicle.delivery.people.Please tell us the number of people driving per week",
        defaultMessage: "Please tell us the number of people driving per week",
    },
    deliveryHours: {
        id: "ml.quoteandbind.pa.vehicle.delivery.hours.Please tell us the number of hours you drive per week",
        defaultMessage: "Please tell us the number of hours you drive per week",
    },
    interlockToolTips: {
        id: "ml.quoteandbind.pa.vehicle.ignitionInterlock.tooltip content",
        defaultMessage: "A participant in Minnesota’s ignition interlock program must provide proof of insurance in order to obtain a driver’s license. The ignition interlock program requires installation of a device in a vehicle that is designed to measure breath alcohol concentration and to prevent such vehicle from being started by an individual whose breath alcohol concentration measures 0.02 or more on the device.",
    },
    vendorAnnualMileage: {
        id: 'ml.quoteandbind.pa.editVehicle.vendorAnnualMileage',
        defaultMessage: 'Vendor Annual Mileage: {value}'
    },
    whatDoesThisMean: {
        id: 'common.directives.templates.ml-pa-agent-edit-vehicle.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    IgnitionInterlock: {
        id: 'ml.quoteandbind.pa.vehicle.IgnitionInterlockInsuranceCertification',
        defaultMessage: 'Do you require a MN Ignition Interlock Insurance Certification Form?'
    },
    WhatDoesThisMeanIgnitionInterlock: {
        id: 'ml.quoteandbind.pa.vehicle.ignitionInterlock.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    interlockExpirationDate: {
        id: 'ml.quoteandbind.pa.vehicle.interlockExpirationDate',
        defaultMessage: 'Interlock Expiration Date'
    },
    repairedLabel: {
        id: 'ml.quoteandbind.pa.vehicle.repairedLabel',
        defaultMessage: 'This vehicle has a salvage title which means it was previously determined to be a total loss. Has this vehicle been repaired?'
    },
    purchasePriceLabel: {
        id: "ml.quoteandbind.pa.editVehicle.purchasePriceField",
        defaultMessage: "Purchase Price"
    },
    agreedValueAmountLabel: {
        id: "ml.quoteandbind.pa.editVehicle.agreedValueAmount",
        defaultMessage: "Agreed Value Amount"
    },
    purchaseDateInputErrorMessage:{
        id: "ml.quoteandbind.pa.editVehicle.purchaseDateInputErrorMessage",
        defaultMessage: "Date cannot be greater than 7 days from today"
    },
    parkedAtPrimary: {
        id: 'ml.quoteandbind.pa.editVehicle.parkedAtPrimary',
        defaultMessage: 'Is the vehicle primarily parked at the insured\'s residence?'
    },
    parkedAtPrimaryTrailer: {
        id: 'ml.quoteandbind.pa.editVehicle.parkedAtPrimaryTrailer',
        defaultMessage: 'Is the trailer primarily parked at the insured\'s residence?'
    },
    tooltipWhatDoesThisMean: {
        id: 'ml.quoteandbind.pa.editVehicle.tooltipWhatDoesThisMean',
        defaultMessage: 'What does this mean?'
    },
    parkingTooltipText: {
        id: 'ml.quoteandbind.pa.editVehicle.parkingTooltipText',
        defaultMessage: 'The vehicle is typically parked at the address listed on the policy. The vehicle can be parked in the garage, carport, on street or off street. If the vehicle is typically parked at a different address, list the address.'
    },
    parkingTooltipTextTrailer: {
        id: 'ml.quoteandbind.pa.editVehicle.parkingTooltipTextTrailer',
        defaultMessage: 'The trailer is typically parked at the address listed on the policy. The trailer can be parked in the garage, carport, on street or off street. If the trailer is typically parked at a different address, list the address.'
    },
    isStorageUseInvalidMsg: {
        id: 'ml.quoteandbind.pa.editVehicle.isStorageUseInvalidMsg',
        defaultMessage: 'Storage use is not available for vehicles with model year less than 1970.'
    },
    matureDriverDiscountWarning: {
        id: 'ml.quoteandbind.pa.editVehicle.matureDriverDiscountWarning',
        defaultMessage: 'Business and Storage Use vehicles are ineligible for the Mature Driver discount. Review and update vehicle assignment as needed.'
    },
    selectGarageError: {
        id: "ml.quoteandbind.pa.editVehicle.garageAddress",
        defaultMessage: "Garage address can not be PO Box"
    },
});
